import { effect, Injectable, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppAuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class BinderSettingsService {
  pdfPricing = signal<boolean>(false);
  showIncluding = signal<boolean>(false);
  profilePriceSetting = false;
  profileIncludedSetting = false;

  constructor(
    private appAuthService: AppAuthService
  ) { 
    effect(() => {
      const profile = this.appAuthService.userData();
      if(profile) {
        this.pdfPricing.set(profile.ShowPrice || false);
        this.showIncluding.set(profile.StandardIncluded || false);
        this.profilePriceSetting = profile.ShowPrice || false
        this.profileIncludedSetting = profile.StandardIncluded || false
      }
    });
  }

  setPdfPricing(value: boolean) {
    this.pdfPricing.set(value);
  }

  resetPricing() {
    this.pdfPricing.set(this.profilePriceSetting);
    this.showIncluding.set(this.profileIncludedSetting);
  }

  setShowIncluding(value: boolean) {
    this.showIncluding.set(value);
  }
  
}
